module.exports = __webpack_public_path__ + "img/fireball.6e07edf9.png";